<template>
  <v-runtime-template class="" :template="html">

  </v-runtime-template>

</template>

<script>
import WidgetMixin from './WidgetMixin';
import VRuntimeTemplate from "v-runtime-template";
import videojs from "video.js";

export default {
  name: "CustomWidget",
  mixins: [WidgetMixin],
  components: {VRuntimeTemplate},

  data() {
    return {
      textfield: null,
      textfield2: null,
      textfield3: null,
      textfield4: null,
      textfield5: null,
      textfield6: null,
      textfield7: null,
      currentTab: null,
      objectfield1: {},
      objectfield2: {},
      objectfield3: {},
      objectfield4: {},
      objectfield5: {},
      objectfield6: {},
      objectfield7: {},
      arrayfield1: [],
      arrayfield2: [],
      arrayfield3: [],
      arrayfield4: [],
      arrayfield5: [],
      arrayfield6: [],
      arrayfield7: [],
      customVariables: {},
      triggerWebhooks: [],

    }
  },

  methods: {

    triggerWebhook(url) {
      if(this.triggerWebhooks.includes(url)) {
        return '';
      }
      this.triggerWebhooks.push(url);
      //get and cancel after 3 seconds
      axios.get(url).then(response => {
        console.log(response);
      }).catch(error => {
        console.log(error);
      });

      return '';


    },

    isValidEmail(email) {
      if(!email) return false;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    getCustomVariable(key, defaultValue=false) {
      if (!(key in this.customVariables)) {
        Vue.set(this.customVariables, key, defaultValue);
      }
      return this.customVariables[key];
    },
    getCustomVariableDelayed(key,startValue, delay,endValue) {
      if (!(key in this.customVariables)) {
        Vue.set(this.customVariables, key, startValue);
        setTimeout(() => {
          Vue.set(this.customVariables, key, endValue);
        }, delay);
      }
      return this.customVariables[key];

    },
    setCustomVariable(key, value) {
      Vue.set(this.customVariables, key, value);
    },
    htmlLoadedCustom() {


      //Check amount of elements with .videoPlayer class
      var videoPlayer = document.querySelectorAll(".videoPlayer");
      if (videoPlayer.length > 0) {
        videojs(
            ".videoPlayer",
            this.playerOptions,
            function onPlayerReady() {
              //   console.log("onPlayerReady", this);
            }
        );
      }


      this.$nextTick(() => {
        (function () {
          const debounce = (fn, delay) => {
            let timeoutId = null
            return () => {
              clearTimeout(timeoutId)
              timeoutId = setTimeout(fn, delay)
            }
          }

          const throttle = (fn, delay) => {
            let waiting = false
            return () => {
              if (!waiting) {
                fn()
                waiting = true
                setTimeout(() => waiting = false, delay)
              }
            }
          }

          const reset = element => {
            if (element.className !== element.dataset.taosClass) {
              element.className = element.dataset.taosClass
            }
          }
          const before = element => element.className = element.className.replaceAll('taos:', '')

          const initElement = element => {
            if (!element.className.includes('taos-init')) {
              element.dataset.taosClass = element.className + ' taos-init'
              reset(element)
            }
            element.className += ' !duration-[0ms] !delay-[0ms]'
            before(element)

            return {
              element,
              once: getComputedStyle(element)['animation-iteration-count'] === '1',
              offset: parseInt(element.dataset.taosOffset || 0)
            }
          }

          let elements = []
          let innerWidth = window.innerWidth
          let scrollY = window.scrollY

          const refreshTriggers = throttle(() => {
            elements.forEach(el => el.trigger = el.element.getBoundingClientRect().top - window.innerHeight + el.offset + scrollY)
          }, 250)


          const refresh = () => {
            elements = []
            document.querySelectorAll('[class*="taos"]').forEach(el => elements.push(initElement(el)))
            refreshTriggers()
            requestAnimationFrame(handleScroll)
          }

          const handleScroll = () => {


            scrollY = window.scrollY
            console.log("SCROLL", scrollY, elements)
            elements.forEach(({element, trigger, once}) => {
              if (trigger < scrollY) {
                reset(element)
              } else if (!once && element.className.includes('taos:')) {
                before(element)
              }
            })
            refreshTriggers()
          }

          const handleResize = () => {
            if (innerWidth !== window.innerWidth) {
              innerWidth = window.innerWidth
              refresh()
            }
          }

          refresh()
          addEventListener('scroll', throttle(handleScroll, 32))
          addEventListener('orientationchange', refresh)
          addEventListener('resize', debounce(handleResize, 250))

          const observer = new MutationObserver(mutations => {
            mutations.forEach(({target}) => {
              if (target.className && !target.className.includes('taos-init') && target.className.includes('taos:')) {
                elements.push(initElement(target))
              }
            })
          })
          observer.observe(document, {attributes: true, childList: true, subtree: true})
        })()
      })

    },
    nl2br(str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
  }
}
</script>

<style scoped>


.terms_html a {

  text-decoration: underline;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(194, 188, 188, 0.2);
  border-right: 1.1em solid rgba(194, 188, 188, 0.2);
  border-bottom: 1.1em solid rgba(194, 188, 188, 0.2);
  border-left: 1.1em solid #c2bcbc;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>